const rooms = (state) => {
  return state.rooms.data
};

const roomsIndividuals = (state) => {
  return state.rooms.data.filter((r) => {
    return r.is_peer_chat
  })
}

const roomsColective = (state) => {
  return state.rooms.data.filter((r) => {
    return !r.is_peer_chat
  })
}

const loadingRooms = (state) => {
  return state.loading_rooms
}

const allUnread = (state) => {
  return rooms(state).reduce((a, b) => {
    return a + b.unread_quantity
  }, 0)
}

const colectiveUnread = (state) => {
  return roomsColective(state).reduce((a, b) => {
    return a + b.unread_quantity
  }, 0)
}

const individualsUnread = (state) => {
  return roomsIndividuals(state).reduce((a, b) => {
    return a + b.unread_quantity
  }, 0)
}

export {
  rooms,
  roomsIndividuals,
  roomsColective,
  allUnread,
  colectiveUnread,
  individualsUnread,
  loadingRooms,
}
